import * as XLSX from 'xlsx';

const COLUMNAS = [
  'Matrícula',
  'Nombre del estudiante',
  'Tipo de beca',
  'Nombre de la Beca',
  'Porcentaje de beca',
  'Monto de Beca',
  'Ciclo de inicio de Beca',
  'Fecha de inicio de la beca',
  'Fecha de término de la beca',
  'Costo de la colegiatura (parcialidad)',
  'Cantidad que paga el estudiante',
  'Cantidad que pagó en un año el estudiante',
];

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

const formatPorcentajeBeca = (value) => {
    if (value === null || value === undefined) return '';
    const text = String(value).trim();
    if (!text) return '';
    if (text.includes('%')) return text;
    return `${text} %`;
};

const formatMoney = (value) => {
    const amount = Number(value ?? 0);
    if (!Number.isFinite(amount)) return '$0.00';
    return `$${amount.toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
};

export function exportReporteBecasXLS({ resultados = [], anio = '', tipoBeca = '' } = {}) {
  const aoa = [
    ['REPORTE DE BECAS'],
    [`Año: ${anio || 'Todos'}`],
    [`Tipo de Beca: ${tipoBeca || 'Todos'}`],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
    [],
    COLUMNAS,
  ];

  resultados.forEach((r) => {
    aoa.push([
      r.matricula,
      r.nombre_estudiante,
      r.tipo_beca,
      r.nombre_beca,
      formatPorcentajeBeca(r.porcentaje_beca),
      r.monto_beca ?? 0,
      r.ciclo_escolar,
      r.fecha_inicio_beca,
      r.fecha_termino_beca,
      formatMoney(r.costo_colegiatura),
      formatMoney(r.cantidad_paga_estudiante),
      formatMoney(r.cantidad_pago_anual),
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = [
    { wch: 15 }, // Matrícula
    { wch: 35 }, // Nombre del estudiante
    { wch: 20 }, // Tipo de beca
    { wch: 25 }, // Nombre de la Beca
    { wch: 20 }, // Porcentaje de beca
    { wch: 15 }, // Monto de Beca
    { wch: 25 }, // Ciclo de inicio de Beca
    { wch: 25 }, // Fecha de inicio de la beca
    { wch: 25 }, // Fecha de término de la beca
    { wch: 30 }, // Costo de la colegiatura (parcialidad)
    { wch: 30 }, // Cantidad que paga el estudiante
    { wch: 40 }, // Cantidad que pagó en un año el estudiante
  ];

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COLUMNAS.length - 1 } },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Becas');

  const fileName = `reporte_becas_${fechaArchivo()}.xlsx`;
  XLSX.writeFile(wb, fileName);
}

export default exportReporteBecasXLS;
